/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentFormatEnum } from './appointmentFormatEnum';
import { CategorizedCancellationReason } from './categorizedCancellationReason';
import { AppointmentStatusEnum } from './appointmentStatusEnum';
import { SessionTypeEnum } from './sessionTypeEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface CalendarAppointmentBookGet { 
    readonly sessionTypes: Array<SessionTypeEnum>;
    readonly appointmentFormats: Array<AppointmentFormatEnum>;
    readonly appointmentStatuses: Array<AppointmentStatusEnum>;
    readonly cancellationReasons: CategorizedCancellationReason;
}
export const CalendarAppointmentBookGet_sessionTypes_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarAppointmentBookGet_appointmentFormats_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarAppointmentBookGet_appointmentStatuses_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarAppointmentBookGet_cancellationReasons_Validators: ValidatorFn[] =
    [  Validators.required, ];


